// Product m2 Calculator — Prindal-Hout
// Extracted from inline <script> into an external, deferred asset file.
// Only runs when explicitly initialized via window.PrindalM2Calc.init(uid) —
// see the lazy-init script at the bottom of snippets/product-m2-calculator.liquid.
// This mirrors the pattern already used for the hek calculator
// (assets/product-hek-calculator.js) so all three calculators behave
// consistently: no calculator JS executes until its tab is actually opened.

window.PrindalM2Calc = (function () {
  function init(uid) {
    var root = document.getElementById(uid);
    if (!root) return;
    if (root.dataset.calcInited === 'true') return; // dubbele init voorkomen
    root.dataset.calcInited = 'true';

    var dataEl = root.querySelector('[data-m2-calc-variants]');
    var calcData = { variants: {}, optionNames: [], isProfessional: false, productId: null, labels: {} };
    try { calcData = JSON.parse(dataEl.textContent); } catch (e) { /* houdt defaults aan */ }
    var variants = calcData.variants || {};
    var optionNames = calcData.optionNames || [];
    var labels = calcData.labels || {};

    var directionButtons = root.querySelectorAll('[data-calc-build-direction] [data-direction]');
    var afterDirection = root.querySelector('[data-calc-after-direction]');
    var afterShape = root.querySelector('[data-calc-after-shape]');
    var shapeButtons = root.querySelectorAll('.m2-calc__top-left > .m2-calc__block > .m2-calc__shape-toggle > [data-shape]');
    var lshapeWrap = root.querySelector('[data-calc-lshape-wrap]');
    var lshapeDimsWrap = root.querySelector('[data-calc-lshape-dims-wrap]');
    var zone1Label = root.querySelector('[data-calc-zone1-label]');
    var zoneSplitNote = root.querySelector('[data-calc-zone-split-note]');
    var shiftBtn = root.querySelector('[data-calc-shift]');
    var rotateBtn = root.querySelector('[data-calc-rotate]');
    var zoneSplitNoteH = labels.zoneSplitNoteH;
    var zoneSplitNoteV = labels.zoneSplitNoteV;

    var l1 = root.querySelector('[data-calc-length1]');
    var w1 = root.querySelector('[data-calc-width1]');
    var l2 = root.querySelector('[data-calc-length2]');
    var w2 = root.querySelector('[data-calc-width2]');

    var colorBlock = root.querySelector('[data-calc-color-block]');
    var colorPickerEl = root.querySelector('[data-calc-color-picker]');
    var widthBlock = root.querySelector('[data-calc-width-block]');
    var widthPickerEl = root.querySelector('[data-calc-width-picker]');
    var perfectProposalEl = root.querySelector('[data-calc-perfect-proposal]');
    var methodBlock = root.querySelector('[data-calc-method-block]');
    var methodButtons = root.querySelectorAll('[data-calc-build-method] [data-method]');
    var wildLengthBlock = root.querySelector('[data-calc-wild-length-block]');
    var wildSummaryEl = root.querySelector('[data-calc-wild-summary]');
    var fullAutoBlock = root.querySelector('[data-calc-full-auto-block]');
    var fullProposalEl = root.querySelector('[data-calc-full-proposal]');

    var elHint = root.querySelector('[data-calc-hint]');
    var elPlankOptions = root.querySelector('[data-calc-plank-options]');
    var elResults = root.querySelector('[data-calc-results]');
    var elArea = root.querySelector('[data-calc-area]');

    var elPriceRows = root.querySelector('[data-calc-price-rows]');
    var elProPriceRows = root.querySelector('[data-calc-pro-price-rows]');
    var elTotalLabel = root.querySelector('[data-calc-total-label]');
    var elTotal = root.querySelector('[data-calc-total]');
    var elProGroup = root.querySelector('[data-calc-pro-group]');
    var elProTotal = root.querySelector('[data-calc-pro-total]');
    var elVoordeel = root.querySelector('[data-calc-voordeel]');
    var elAdd = root.querySelector('[data-calc-add]');
    var elAddError = root.querySelector('[data-calc-add-error]');

    var previewShape = root.querySelector('[data-calc-preview-shape]');
    var previewLines = root.querySelector('[data-calc-preview-lines]');
    var previewFullZones = root.querySelector('[data-calc-preview-full-zones]');
    var previewLabels = root.querySelector('[data-calc-preview-labels]');
    var previewZoneLabels = root.querySelector('[data-calc-preview-zone-labels]');
    var previewDivider = root.querySelector('[data-calc-preview-divider]');
    var previewEmptyNote = root.querySelector('[data-calc-preview-empty-note]');

    var defaultHintText = elHint.textContent;
    var addLabelBase = labels.addToCart;
    var addedLabel = labels.added;
    var addingLabel = labels.adding;
    var piecesLabel = labels.pieces;
    var totalPlainLabel = labels.totalPlain;
    var totalParticulierLabel = labels.totalParticulier;
    var exclVatLabel = labels.exclVat;
    var mmLabel = ' cm';
    var chooseLengthLabel = labels.chooseLength;
    var perfectTitleLabel = labels.perfectTitle;
    var perfectAltNoteLabel = labels.perfectAltNote;
    var fullProposalTitleLabel = labels.fullProposalTitle;
    var fullAltNoteLabel = labels.fullAltNote;
    var planksOfLabel = labels.planksOf;
    var wholeForLabel = labels.wholeFor;
    var cutForLabel = labels.cutFor;
    var andLabel = labels.and;
    var forZone1Label = labels.forZone1;
    var forZone2Label = labels.forZone2;
    var zone3TitleLabel = labels.zone3Title;
    var zone4TitleLabel = labels.zone4Title;
    var piecesOfLabel = labels.piecesOf;
    var zone1TitleLabel = labels.zone1Title;
    var zone2TitleLabel = labels.zone2Title;

    var shape = 'rect';
    var shifted = false;
    var buildDirection = null;
    var buildMethod = null;
    var rotationSteps = 0;
    var adviesRevealed = false;

    var state = {
      colorKey: null,
      widthCm: null,
      zoneLengthWild: { 1: null, 2: null },
      perfectChoiceIndex: 0,
      fullChoiceIndex: 0
    };
    var rectState = {
      1: { orientation: 'horizontal', variantId: null },
      2: { orientation: 'horizontal', variantId: null }
    };
    var currentSpareEntries = [];
    var currentFullVisual = null;
    var currentUsageQty = {};
    var proUnitCentsByVariant = {};
    var proSyncPending = {};
    var proSyncQueue = [];
    var proSyncInFlight = false;
    function requestProSync(variantId) {
      if (!variantId) return;
      if (proUnitCentsByVariant[variantId] != null) return;
      if (proSyncPending[variantId]) return;
      proSyncPending[variantId] = true;
      proSyncQueue.push(variantId);
      processProSyncQueue();
    }
    function processProSyncQueue() {
      if (proSyncInFlight || !proSyncQueue.length) return;
      proSyncInFlight = true;
      var variantId = proSyncQueue.shift();
      syncProPricing(variantId, function () {
        proSyncInFlight = false;
        processProSyncQueue();
      });
    }

    var isProfessional = !!calcData.isProfessional;

    function formatMoney(cents) {
      var euros = cents / 100;
      return '\u20AC ' + euros.toFixed(2).replace('.', ',');
    }
    function formatMeters(val) {
      var rounded = Math.round(val * 100) / 100;
      return String(rounded).replace('.', ',') + ' m';
    }

    function detectSizeOptionIndex() {
      for (var idx = 0; idx < optionNames.length; idx++) {
        var valueToSize = {}; var consistent = true; var hasMultiple = false;
        for (var id in variants) {
          var v = variants[id];
          var val = v.options[idx];
          var sizeKey = v.plankWidthCm + '|' + v.plankLengthM;
          if (Object.prototype.hasOwnProperty.call(valueToSize, val)) {
            if (valueToSize[val] !== sizeKey) { consistent = false; break; }
          } else { valueToSize[val] = sizeKey; }
        }
        if (!consistent) continue;
        hasMultiple = Object.keys(valueToSize).length > 1;
        if (hasMultiple || optionNames.length === 1) return idx;
      }
      return 0;
    }
    var sizeOptionIndex = detectSizeOptionIndex();

    function colorKeyForVariant(v) {
      var parts = [];
      for (var i = 0; i < v.options.length; i++) { if (i !== sizeOptionIndex) parts.push(v.options[i]); }
      return parts.length ? parts.join(' / ') : null;
    }

    function getAvailableColors() {
      var seen = {}; var out = [];
      for (var id in variants) {
        var ck = colorKeyForVariant(variants[id]);
        if (ck === null) continue;
        if (!seen[ck]) { seen[ck] = true; out.push(ck); }
      }
      return out;
    }
    function getAvailableWidths(colorKey) {
      var seen = {}; var out = [];
      for (var id in variants) {
        var v = variants[id];
        if (!v.plankWidthCm) continue;
        if (colorKey !== null && colorKeyForVariant(v) !== colorKey) continue;
        if (!seen[v.plankWidthCm]) { seen[v.plankWidthCm] = true; out.push(v.plankWidthCm); }
      }
      out.sort(function (a, b) { return a - b; });
      return out;
    }
    function getAvailableLengths(colorKey, widthCm) {
      var seen = {}; var out = [];
      for (var id in variants) {
        var v = variants[id];
        if (!v.plankWidthCm || Math.abs(v.plankWidthCm - widthCm) > 0.01 || !v.plankLengthM) continue;
        if (colorKey !== null && colorKeyForVariant(v) !== colorKey) continue;
        if (!seen[v.plankLengthM]) { seen[v.plankLengthM] = true; out.push(v.plankLengthM); }
      }
      out.sort(function (a, b) { return a - b; });
      return out;
    }
    function variantFor(colorKey, widthCm, lengthM) {
      if (widthCm == null || lengthM == null || isNaN(widthCm) || isNaN(lengthM)) return null;
      for (var id in variants) {
        var v = variants[id];
        if (!v.plankWidthCm || Math.abs(v.plankWidthCm - widthCm) > 0.01) continue;
        if (!v.plankLengthM || Math.abs(v.plankLengthM - lengthM) > 0.005) continue;
        if (colorKey !== null && colorKeyForVariant(v) !== colorKey) continue;
        return id;
      }
      return null;
    }

    function getRowInfo(rectNum) {
      var lengthM = rectNum === 1 ? parseFloat(l1.value) || 0 : parseFloat(l2.value) || 0;
      var widthM = rectNum === 1 ? parseFloat(w1.value) || 0 : parseFloat(w2.value) || 0;
      var orientation = rectState[rectNum].orientation;
      return orientation === 'horizontal' ? { rowLength: lengthM, crossDim: widthM } : { rowLength: widthM, crossDim: lengthM };
    }
    function getNumRows(rectNum, plankWidthCm) {
      var row = getRowInfo(rectNum);
      var plankWidthWithVoidM = (plankWidthCm + 0.5) / 100;
      return Math.ceil((row.crossDim - 0.005) / plankWidthWithVoidM);
    }

    function calcPlanksWild(lengthM, widthM, variant) {
      return Math.ceil((lengthM * widthM) / variant.m2);
    }

    function findPerfectNoCutOptions(row1, row2, lengths) {
      var EPS = 0.005;
      var out = [];
      lengths.forEach(function (L1) {
        var rem1 = row1 % L1;
        var fits1 = rem1 < EPS || (L1 - rem1) < EPS;
        if (!fits1) return;
        if (row2 <= 0) {
          out.push({ length1: L1, length2: null });
        } else {
          lengths.forEach(function (L2) {
            var rem2 = row2 % L2;
            var fits2 = rem2 < EPS || (L2 - rem2) < EPS;
            if (fits2) out.push({ length1: L1, length2: L2 });
          });
        }
      });
      return out;
    }

    function generateCutPatterns(plankLengthM, r1, r2) {
      var EPS = 0.005; var patterns = [];
      var maxA = r1 > 0 ? Math.floor((plankLengthM + EPS) / r1) : 0;
      for (var a = 0; a <= maxA; a++) {
        var leftover = plankLengthM - a * r1;
        var maxB = r2 > 0 ? Math.floor((leftover + EPS) / r2) : 0;
        for (var b = 0; b <= maxB; b++) {
          if (a === 0 && b === 0) continue;
          patterns.push({ a: a, b: b, waste: plankLengthM - (a * r1 + b * r2) });
        }
      }
      return patterns;
    }
    function bestSpareAllocation(plankLengthM, r1, need1, r2, need2) {
      var patterns = generateCutPatterns(plankLengthM, r1, r2);
      if (!patterns.length) return null;
      var N1 = Math.round(need1), N2 = Math.round(need2);
      if (N1 === 0 && N2 === 0) return { planksNeeded: 0, totalWaste: 0, patternUsage: [] };
      if (N1 > 500 || N2 > 500) return null;

      var dp = [];
      for (var i = 0; i <= N1; i++) { dp.push(new Array(N2 + 1).fill(Infinity)); }
      dp[0][0] = 0;
      for (var ii = 0; ii <= N1; ii++) {
        for (var jj = 0; jj <= N2; jj++) {
          if (ii === 0 && jj === 0) continue;
          var best = Infinity;
          for (var k = 0; k < patterns.length; k++) {
            var p = patterns[k];
            var pi = Math.max(0, ii - p.a);
            var pj = Math.max(0, jj - p.b);
            var val = dp[pi][pj];
            if (val + 1 < best) best = val + 1;
          }
          dp[ii][jj] = best;
        }
      }
      var planksNeeded = dp[N1][N2];
      if (planksNeeded === Infinity) return null;

      var usageMap = {};
      var ci = N1, cj = N2, safety = 0;
      while ((ci > 0 || cj > 0) && safety < 10000) {
        safety++;
        var chosen = null;
        for (var k2 = 0; k2 < patterns.length; k2++) {
          var p2 = patterns[k2];
          var pi2 = Math.max(0, ci - p2.a);
          var pj2 = Math.max(0, cj - p2.b);
          if (dp[pi2][pj2] + 1 === dp[ci][cj]) { chosen = p2; break; }
        }
        if (!chosen) break;
        var key = chosen.a + '_' + chosen.b;
        if (!usageMap[key]) usageMap[key] = { a: chosen.a, b: chosen.b, count: 0 };
        usageMap[key].count++;
        ci = Math.max(0, ci - chosen.a);
        cj = Math.max(0, cj - chosen.b);
      }
      var patternUsage = Object.keys(usageMap).map(function (k) { return usageMap[k]; });
      var totalWaste = planksNeeded * plankLengthM - (N1 * r1 + N2 * r2);
      return { planksNeeded: planksNeeded, totalWaste: totalWaste, patternUsage: patternUsage };
    }
    function refineSpareLengthsPerEntry(patternUsage, r1, r2, lengthOptions) {
      var refined = [];
      patternUsage.forEach(function (entry) {
        if (entry.a > 0 && entry.b === 0) {
          var totalPieces = entry.a * entry.count;
          var best = null;
          lengthOptions.forEach(function (L) {
            var piecesPerPlank = Math.floor((L + 0.005) / r1);
            if (piecesPerPlank < 1) return;
            var planksNeeded = Math.ceil(totalPieces / piecesPerPlank);
            var waste = planksNeeded * L - totalPieces * r1;
            if (!best || waste < best.waste - 0.0001 || (Math.abs(waste - best.waste) < 0.0001 && planksNeeded < best.planksNeeded)) {
              best = { lengthM: L, piecesPerPlank: piecesPerPlank, planksNeeded: planksNeeded, waste: waste };
            }
          });
          refined.push(best ? { a: best.piecesPerPlank, b: 0, count: best.planksNeeded, lengthM: best.lengthM } : { a: entry.a, b: 0, count: entry.count, lengthM: null });
        } else if (entry.b > 0 && entry.a === 0) {
          var totalPiecesB = entry.b * entry.count;
          var bestB = null;
          lengthOptions.forEach(function (L) {
            var piecesPerPlank = Math.floor((L + 0.005) / r2);
            if (piecesPerPlank < 1) return;
            var planksNeeded = Math.ceil(totalPiecesB / piecesPerPlank);
            var waste = planksNeeded * L - totalPiecesB * r2;
            if (!bestB || waste < bestB.waste - 0.0001 || (Math.abs(waste - bestB.waste) < 0.0001 && planksNeeded < bestB.planksNeeded)) {
              bestB = { lengthM: L, piecesPerPlank: piecesPerPlank, planksNeeded: planksNeeded, waste: waste };
            }
          });
          refined.push(bestB ? { a: 0, b: bestB.piecesPerPlank, count: bestB.planksNeeded, lengthM: bestB.lengthM } : { a: 0, b: entry.b, count: entry.count, lengthM: null });
        } else {
          var neededSpace = entry.a * r1 + entry.b * r2;
          var bestLen = null;
          lengthOptions.forEach(function (L) {
            if (L + 0.005 >= neededSpace && (bestLen === null || L < bestLen)) bestLen = L;
          });
          refined.push({ a: entry.a, b: entry.b, count: entry.count, lengthM: bestLen });
        }
      });
      return refined;
    }

    function optimizeFullMethod(row1, rows1, row2, rows2, lengthOptions) {
      var EPS = 0.005; var allCandidates = [];
      lengthOptions.forEach(function (mainLen) {
        var mainPerRow1 = Math.floor((row1 + EPS) / mainLen);
        var rem1 = row1 - mainPerRow1 * mainLen; if (rem1 < EPS) rem1 = 0;
        var mainTotal1 = rows1 * mainPerRow1;
        var mainPerRow2 = 0, rem2 = 0, mainTotal2 = 0;
        if (rows2 > 0) {
          mainPerRow2 = Math.floor((row2 + EPS) / mainLen);
          rem2 = row2 - mainPerRow2 * mainLen; if (rem2 < EPS) rem2 = 0;
          mainTotal2 = rows2 * mainPerRow2;
        }
        var needSpares = rem1 > 0 || rem2 > 0;
        var spare = null;
        if (needSpares) {
          var need1ForSpare = rem1 > 0 ? rows1 : 0;
          var need2ForSpare = rem2 > 0 ? rows2 : 0;
          var bestSpare = null;
          lengthOptions.forEach(function (spareLen) {
            var res = bestSpareAllocation(spareLen, rem1, need1ForSpare, rem2, need2ForSpare);
            if (!res) return;
            if (!bestSpare || res.planksNeeded < bestSpare.result.planksNeeded ||
                (res.planksNeeded === bestSpare.result.planksNeeded && res.totalWaste < bestSpare.result.totalWaste - 0.0001)) {
              bestSpare = { lengthM: spareLen, result: res };
            }
          });
          if (!bestSpare) return;
          spare = bestSpare;
        }
        var refinedUsage = spare ? refineSpareLengthsPerEntry(spare.result.patternUsage, rem1, rem2, lengthOptions) : [];
        var refinedSparePlanks = 0, totalWaste = 0;
        refinedUsage.forEach(function (e) {
          refinedSparePlanks += e.count;
          if (e.lengthM != null) totalWaste += e.count * (e.lengthM - e.a * rem1 - e.b * rem2);
        });
        var totalPlanks = mainTotal1 + mainTotal2 + refinedSparePlanks;
        allCandidates.push({
          mainLengthM: mainLen, mainPerRow1: mainPerRow1, rem1: rem1, mainTotal1: mainTotal1,
          mainPerRow2: mainPerRow2, rem2: rem2, mainTotal2: mainTotal2,
          sparePlanks: refinedSparePlanks,
          sparePatternUsage: refinedUsage,
          totalPlanks: totalPlanks, totalWaste: totalWaste
        });
      });
      if (!allCandidates.length) return null;
      allCandidates.sort(function (a, b) {
        if (a.totalPlanks !== b.totalPlanks) return a.totalPlanks - b.totalPlanks;
        return a.totalWaste - b.totalWaste;
      });
      return allCandidates;
    }

    function lengthsUsedInFullResult(r) {
      var lens = [r.mainLengthM];
      r.sparePatternUsage.forEach(function (e) {
        if (e.lengthM != null && Math.abs(e.lengthM - r.mainLengthM) > 0.005 && lens.indexOf(e.lengthM) === -1) lens.push(e.lengthM);
      });
      return lens;
    }

    function describeFullResult(r, needsRect2) {
      var mainLines = [];
      if (needsRect2 && r.mainTotal1 > 0 && r.mainTotal2 > 0) {
        mainLines.push('<strong>' + (r.mainTotal1 + r.mainTotal2) + '</strong> ' + planksOfLabel + ' ' + formatMeters(r.mainLengthM) +
          ' \u2014 ' + r.mainTotal1 + ' ' + wholeForLabel + ' ' + forZone1Label + ' ' + andLabel + ' ' + r.mainTotal2 + ' ' + wholeForLabel + ' ' + forZone2Label);
      } else if (r.mainTotal1 > 0 && (!needsRect2 || r.mainTotal2 === 0)) {
        mainLines.push('<strong>' + r.mainTotal1 + '</strong> ' + planksOfLabel + ' ' + formatMeters(r.mainLengthM) + (needsRect2 ? ' \u2014 ' + forZone1Label : ''));
      } else if (r.mainTotal2 > 0) {
        mainLines.push('<strong>' + r.mainTotal2 + '</strong> ' + planksOfLabel + ' ' + formatMeters(r.mainLengthM) + ' \u2014 ' + forZone2Label);
      }
      var spareEntries = [];
      if (r.sparePlanks > 0 && r.sparePatternUsage) {
        var zone1RemLabel = needsRect2 ? zone3TitleLabel : zone2TitleLabel;
        var zone2RemLabel = zone4TitleLabel;
        r.sparePatternUsage.forEach(function (pu) {
          if (pu.lengthM == null) return;
          var descr = [];
          if (pu.a > 0) descr.push(pu.a + ' ' + piecesOfLabel + ' ' + formatMeters(r.rem1) + ' (' + zone1RemLabel + ')');
          if (pu.b > 0) descr.push(pu.b + ' ' + piecesOfLabel + ' ' + formatMeters(r.rem2) + ' (' + zone2RemLabel + ')');
          spareEntries.push({
            count: pu.count,
            html: '+ <strong>' + pu.count + '</strong> ' + planksOfLabel + ' ' + formatMeters(pu.lengthM) + ' \u2014 ' + cutForLabel + ' ' + descr.join(' ' + andLabel + ' ')
          });
        });
      }
      spareEntries.sort(function (a, b) { return b.count - a.count; });
      return mainLines.concat(spareEntries.map(function (e) { return e.html; }));
    }

    function applyAutoOrientation() { rectState[1].orientation = buildDirection; rectState[2].orientation = buildDirection; }
    directionButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buildDirection = btn.getAttribute('data-direction');
        directionButtons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        applyAutoOrientation();
        afterDirection.hidden = false;
        zoneSplitNote.textContent = buildDirection === 'horizontal' ? zoneSplitNoteH : zoneSplitNoteV;
        root.querySelectorAll('[data-lvorm-direction-img]').forEach(function (el) {
          el.hidden = el.getAttribute('data-lvorm-direction-img') !== buildDirection;
        });
        recalc();
      });
    });

    if (shiftBtn) shiftBtn.addEventListener('click', function () { shifted = !shifted; shiftBtn.classList.toggle('is-active', shifted); recalc(); });
    if (rotateBtn) rotateBtn.addEventListener('click', function () { rotationSteps = (rotationSteps + 1) % 4; recalc(); });

    var DIR_OFFSETS = {
      up: { dx: 0, dy: -12, anchor: 'middle' }, down: { dx: 0, dy: 20, anchor: 'middle' },
      left: { dx: -12, dy: 4, anchor: 'end' }, right: { dx: 12, dy: 4, anchor: 'start' }
    };
    var DIR_ROTATE_CW = { up: 'right', right: 'down', down: 'left', left: 'up' };
    function rotateDir(dir, steps) { var d = dir; for (var i = 0; i < steps; i++) d = DIR_ROTATE_CW[d]; return d; }
    function rotatePoint(p, steps) { var x = p[0], y = p[1]; for (var i = 0; i < steps; i++) { var nx = -y, ny = x; x = nx; y = ny; } return [x, y]; }

    function buildSideBySideShape(l1v, w1v, l2v, w2v) {
      var totalH = Math.max(w1v, w2v); var totalW = l1v + l2v;
      var zone1Y0 = shifted ? (totalH - w1v) : 0; var zone2Y0 = shifted ? (totalH - w2v) : 0;
      var pts;
      if (!shifted) { pts = [[0, 0], [totalW, 0], [totalW, w2v], [l1v, w2v], [l1v, w1v], [0, w1v]]; }
      else { pts = [[0, zone1Y0], [l1v, zone1Y0], [l1v, zone2Y0], [totalW, zone2Y0], [totalW, totalH], [0, totalH]]; }
      var zone1EdgeY = shifted ? zone1Y0 : w1v; var zone1Dir = shifted ? 'up' : 'down';
      return {
        pts: pts, totalW: totalW, totalH: totalH,
        labels: [
          { x: l1v / 2, y: zone1EdgeY, text: l1v ? formatMeters(l1v) : '', dir: zone1Dir },
          { x: 0, y: zone1Y0 + w1v / 2, text: w1v ? formatMeters(w1v) : '', dir: 'left' },
          { x: l1v + l2v / 2, y: zone2Y0, text: l2v ? formatMeters(l2v) : '', dir: 'up' },
          { x: totalW, y: zone2Y0 + w2v / 2, text: w2v ? formatMeters(w2v) : '', dir: 'right' }
        ],
        rectBoxes: [{ num: 1, x: 0, y: zone1Y0, w: l1v, h: w1v }, { num: 2, x: l1v, y: zone2Y0, w: l2v, h: w2v }]
      };
    }
    function buildStackedShape(l1v, w1v, l2v, w2v) {
      var rect1X0 = 0, rect1X1 = l1v; var rect2X0 = shifted ? (l1v - l2v) : 0; var rect2X1 = rect2X0 + l2v;
      var minX = Math.min(rect1X0, rect2X0);
      var r1x0 = rect1X0 - minX, r1x1 = rect1X1 - minX; var r2x0 = rect2X0 - minX, r2x1 = rect2X1 - minX;
      var totalW = Math.max(r1x1, r2x1); var totalH = w1v + w2v;
      var pts;
      if (!shifted) { pts = [[r2x0, 0], [r2x1, 0], [r2x1, w2v], [r1x1, w2v], [r1x1, totalH], [r2x0, totalH]]; }
      else { pts = [[r1x0, w2v], [r2x0, w2v], [r2x0, 0], [r2x1, 0], [r2x1, totalH], [r1x0, totalH]]; }
      var sideX1 = shifted ? r1x0 : r1x1; var sideX2 = shifted ? r2x0 : r2x1; var sideDir = shifted ? 'left' : 'right';
      return {
        pts: pts, totalW: totalW, totalH: totalH,
        labels: [
          { x: (r1x0 + r1x1) / 2, y: totalH, text: l1v ? formatMeters(l1v) : '', dir: 'down' },
          { x: sideX1, y: (w2v + totalH) / 2, text: w1v ? formatMeters(w1v) : '', dir: sideDir },
          { x: (r2x0 + r2x1) / 2, y: 0, text: l2v ? formatMeters(l2v) : '', dir: 'up' },
          { x: sideX2, y: w2v / 2, text: w2v ? formatMeters(w2v) : '', dir: sideDir }
        ],
        rectBoxes: [{ num: 1, x: r1x0, y: w2v, w: l1v, h: w1v }, { num: 2, x: r2x0, y: 0, w: l2v, h: w2v }]
      };
    }
    function buildBaseShape() {
      var l1m = parseFloat(l1.value) || 0; var w1m = parseFloat(w1.value) || 0;
      if (shape !== 'l') {
        return {
          pts: [[0, 0], [l1m, 0], [l1m, w1m], [0, w1m]], totalW: l1m, totalH: w1m,
          labels: [
            { x: l1m / 2, y: 0, text: l1m ? formatMeters(l1m) : '', dir: 'up' },
            { x: 0, y: w1m / 2, text: w1m ? formatMeters(w1m) : '', dir: 'left' }
          ],
          rectBoxes: [{ num: 1, x: 0, y: 0, w: l1m, h: w1m }]
        };
      }
      var l2m = parseFloat(l2.value) || 0; var w2m = parseFloat(w2.value) || 0;
      if (buildDirection === 'horizontal') return buildStackedShape(l1m, w1m, l2m, w2m);
      return buildSideBySideShape(l1m, w1m, l2m, w2m);
    }
    function buildPlankLinesForBox(box, rectNum) {
      var lines = [];
      var vId = rectState[rectNum].variantId;
      var v = vId ? variants[vId] : null;
      var plankWidthM = (v && v.plankWidthCm > 0) ? v.plankWidthCm / 100 : 0.15;
      if (plankWidthM <= 0) return lines;
      var orientation = rectState[rectNum].orientation;
      var safety = 0;
      if (orientation === 'vertical') {
        var x = Math.floor(box.x / plankWidthM + 1) * plankWidthM;
        while (x < box.x + box.w - 0.001 && safety < 60) { lines.push([[x, box.y], [x, box.y + box.h]]); x += plankWidthM; safety++; }
      } else {
        var y = Math.floor(box.y / plankWidthM + 1) * plankWidthM;
        while (y < box.y + box.h - 0.001 && safety < 60) { lines.push([[box.x, y], [box.x + box.w, y]]); y += plankWidthM; safety++; }
      }
      return lines;
    }
    function rotateBox(box, steps) {
      if (steps === 0) return box;
      var corners = [[box.x, box.y], [box.x + box.w, box.y], [box.x + box.w, box.y + box.h], [box.x, box.y + box.h]].map(function (p) { return rotatePoint(p, steps); });
      var cxs = corners.map(function (p) { return p[0]; }); var cys = corners.map(function (p) { return p[1]; });
      var minCx = Math.min.apply(null, cxs), maxCx = Math.max.apply(null, cxs);
      var minCy = Math.min.apply(null, cys), maxCy = Math.max.apply(null, cys);
      return { num: box.num, x: minCx, y: minCy, w: maxCx - minCx, h: maxCy - minCy };
    }
    function computeSharedEdge(boxA, boxB) {
      var EPS = 0.01;
      var aRight = boxA.x + boxA.w, aBottom = boxA.y + boxA.h; var bRight = boxB.x + boxB.w, bBottom = boxB.y + boxB.h;
      if (Math.abs(aBottom - boxB.y) < EPS || Math.abs(bBottom - boxA.y) < EPS) {
        var y = Math.abs(aBottom - boxB.y) < EPS ? aBottom : bBottom;
        var x0 = Math.max(boxA.x, boxB.x); var x1 = Math.min(aRight, bRight);
        if (x1 > x0) return { x1: x0, y1: y, x2: x1, y2: y };
      }
      if (Math.abs(aRight - boxB.x) < EPS || Math.abs(bRight - boxA.x) < EPS) {
        var x = Math.abs(aRight - boxB.x) < EPS ? aRight : bRight;
        var y0b = Math.max(boxA.y, boxB.y); var y1b = Math.min(aBottom, bBottom);
        if (y1b > y0b) return { x1: x, y1: y0b, x2: x, y2: y1b };
      }
      return null;
    }
    function computeFullZoneBoxes(rotatedBoxes) {
      if (!currentFullVisual) return [];
      var out = [];
      rotatedBoxes.forEach(function (box) {
        var info = box.num === 1 ? currentFullVisual.zone1 : currentFullVisual.zone2;
        if (!info) return;
        var orientation = rectState[box.num].orientation;
        var usedLength = info.mainPerRow * info.mainLengthM;
        var hasMain = usedLength > 0.001;
        var hasRem = info.rem > 0.001;
        if (orientation === 'horizontal') {
          if (hasMain) out.push({ zoneNum: box.num, kind: 'main', x: box.x, y: box.y, w: usedLength, h: box.h });
          if (hasRem) out.push({ zoneNum: box.num, kind: 'rem', x: box.x + usedLength, y: box.y, w: box.w - usedLength, h: box.h });
        } else {
          if (hasMain) out.push({ zoneNum: box.num, kind: 'main', x: box.x, y: box.y, w: box.w, h: usedLength });
          if (hasRem) out.push({ zoneNum: box.num, kind: 'rem', x: box.x, y: box.y + usedLength, w: box.w, h: box.h - usedLength });
        }
      });
      return out;
    }
    function buildShapePoints() {
      var base = buildBaseShape();
      if (base.totalW <= 0 || base.totalH <= 0) return { pts: [], totalW: 0, totalH: 0, labels: [], lines: [], zoneLabels: [], dividerLine: null, fullZoneBoxes: [] };
      var steps = rotationSteps % 4;
      var rotatedPts, totalW, totalH, rotatedLabels, minX = 0, minY = 0, rotatedBoxes;
      if (steps === 0) { rotatedPts = base.pts; totalW = base.totalW; totalH = base.totalH; rotatedLabels = base.labels; rotatedBoxes = base.rectBoxes; }
      else {
        var rp = base.pts.map(function (p) { return rotatePoint(p, steps); });
        var xs = rp.map(function (p) { return p[0]; }); var ys = rp.map(function (p) { return p[1]; });
        minX = Math.min.apply(null, xs); minY = Math.min.apply(null, ys);
        rotatedPts = rp.map(function (p) { return [p[0] - minX, p[1] - minY]; });
        totalW = Math.max.apply(null, rotatedPts.map(function (p) { return p[0]; }));
        totalH = Math.max.apply(null, rotatedPts.map(function (p) { return p[1]; }));
        rotatedLabels = base.labels.map(function (lbl) {
          var rp2 = rotatePoint([lbl.x, lbl.y], steps);
          return { x: rp2[0] - minX, y: rp2[1] - minY, text: lbl.text, dir: rotateDir(lbl.dir, steps) };
        });
        rotatedBoxes = base.rectBoxes.map(function (box) { var rb = rotateBox(box, steps); return { num: rb.num, x: rb.x - minX, y: rb.y - minY, w: rb.w, h: rb.h }; });
      }
      var lines = [];
      rotatedBoxes.forEach(function (box) { lines = lines.concat(buildPlankLinesForBox(box, box.num)); });
      var fullZoneBoxes = computeFullZoneBoxes(rotatedBoxes);
      var zoneLabels = [], dividerLine = null;
      if (rotatedBoxes.length === 2 && rotatedBoxes[0].w > 0.001 && rotatedBoxes[0].h > 0.001 && rotatedBoxes[1].w > 0.001 && rotatedBoxes[1].h > 0.001) {
        zoneLabels = rotatedBoxes.map(function (box) {
          var mainSub = fullZoneBoxes.find(function (fb) { return fb.zoneNum === box.num && fb.kind === 'main'; });
          if (!mainSub && currentFullVisual) {
            return { x: box.x + box.w / 2, y: box.y + box.h / 2, text: '' };
          }
          var cx = mainSub ? mainSub.x + mainSub.w / 2 : box.x + box.w / 2;
          var cy = mainSub ? mainSub.y + mainSub.h / 2 : box.y + box.h / 2;
          return { x: cx, y: cy, text: box.num === 1 ? zone1TitleLabel : zone2TitleLabel };
        });
        dividerLine = computeSharedEdge(rotatedBoxes[0], rotatedBoxes[1]);
      }
      return { pts: rotatedPts, totalW: totalW, totalH: totalH, labels: rotatedLabels, lines: lines, zoneLabels: zoneLabels, dividerLine: dividerLine, fullZoneBoxes: fullZoneBoxes };
    }
    function updatePreview() {
      var s = buildDirection ? buildShapePoints() : { pts: [], totalW: 0, totalH: 0, labels: [], lines: [], zoneLabels: [], dividerLine: null, fullZoneBoxes: [] };
      if (s.totalW <= 0 || s.totalH <= 0) {
        previewShape.setAttribute('opacity', '0');
        previewLabels.innerHTML = ''; previewLines.innerHTML = ''; previewZoneLabels.innerHTML = ''; previewDivider.innerHTML = ''; previewFullZones.innerHTML = '';
        if (previewEmptyNote) previewEmptyNote.setAttribute('opacity', '1');
        return;
      }
      if (previewEmptyNote) previewEmptyNote.setAttribute('opacity', '0');
      var viewW = 320, viewH = 300, padTop = 40, padSide = 56, padBottom = 40;
      var drawW = viewW - padSide * 2, drawH = viewH - padTop - padBottom;
      var scale = Math.min(drawW / s.totalW, drawH / s.totalH);
      var offsetX = padSide + (drawW - s.totalW * scale) / 2; var offsetY = padTop + (drawH - s.totalH * scale) / 2;
      var ptsStr = s.pts.map(function (p) { return (offsetX + p[0] * scale).toFixed(1) + ',' + (offsetY + p[1] * scale).toFixed(1); }).join(' ');
      previewShape.setAttribute('points', ptsStr); previewShape.setAttribute('opacity', '1');
      previewLines.innerHTML = '';
      s.lines.forEach(function (seg) {
        var line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
        line.setAttribute('x1', offsetX + seg[0][0] * scale); line.setAttribute('y1', offsetY + seg[0][1] * scale);
        line.setAttribute('x2', offsetX + seg[1][0] * scale); line.setAttribute('y2', offsetY + seg[1][1] * scale);
        line.setAttribute('class', 'm2-calc__preview-plankline');
        previewLines.appendChild(line);
      });
      previewDivider.innerHTML = '';
      if (s.dividerLine) {
        var dl = document.createElementNS('http://www.w3.org/2000/svg', 'line');
        dl.setAttribute('x1', offsetX + s.dividerLine.x1 * scale); dl.setAttribute('y1', offsetY + s.dividerLine.y1 * scale);
        dl.setAttribute('x2', offsetX + s.dividerLine.x2 * scale); dl.setAttribute('y2', offsetY + s.dividerLine.y2 * scale);
        dl.setAttribute('class', 'm2-calc__preview-divider');
        previewDivider.appendChild(dl);
      }
      previewFullZones.innerHTML = '';
      if (s.fullZoneBoxes && s.fullZoneBoxes.length) {
        s.fullZoneBoxes.forEach(function (fb) {
          var rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
          rect.setAttribute('x', offsetX + fb.x * scale);
          rect.setAttribute('y', offsetY + fb.y * scale);
          rect.setAttribute('width', fb.w * scale);
          rect.setAttribute('height', fb.h * scale);
          var cls = fb.zoneNum === 1
            ? (fb.kind === 'main' ? 'm2-calc__preview-full-box--z1main' : 'm2-calc__preview-full-box--z1rem')
            : (fb.kind === 'main' ? 'm2-calc__preview-full-box--z2main' : 'm2-calc__preview-full-box--z2rem');
          rect.setAttribute('class', 'm2-calc__preview-full-box ' + cls);
          previewFullZones.appendChild(rect);

          var orientation = rectState[fb.zoneNum].orientation;
          var extentM = orientation === 'horizontal' ? fb.w : fb.h;
          var thin = fb.w * scale < 26 || fb.h * scale < 16;

          if (fb.kind === 'rem') {
            var labelText = fb.zoneNum === 1 ? zone3TitleLabel : zone4TitleLabel;
            var labelColor = fb.zoneNum === 1 ? '#3a9b3a' : '#7c3aad';
            var cx = offsetX + (fb.x + fb.w / 2) * scale;
            var cy = offsetY + (fb.y + fb.h / 2) * scale;
            var lx = cx, ly = cy;
            if (thin) {
              ly = offsetY + fb.y * scale - 10;
              var connector = document.createElementNS('http://www.w3.org/2000/svg', 'line');
              connector.setAttribute('x1', cx); connector.setAttribute('y1', ly + 3);
              connector.setAttribute('x2', cx); connector.setAttribute('y2', cy);
              connector.setAttribute('stroke', labelColor); connector.setAttribute('stroke-width', '1');
              previewFullZones.appendChild(connector);
            }
            var lbl = document.createElementNS('http://www.w3.org/2000/svg', 'text');
            lbl.setAttribute('x', lx); lbl.setAttribute('y', ly);
            lbl.setAttribute('text-anchor', 'middle');
            lbl.setAttribute('class', 'm2-calc__preview-full-label');
            lbl.setAttribute('fill', labelColor);
            lbl.textContent = labelText;
            previewFullZones.appendChild(lbl);

            var dimEl = document.createElementNS('http://www.w3.org/2000/svg', 'text');
            dimEl.setAttribute('x', lx);
            dimEl.setAttribute('y', thin ? ly - 11 : cy + 13);
            dimEl.setAttribute('text-anchor', 'middle');
            dimEl.setAttribute('class', 'm2-calc__preview-full-dim');
            dimEl.setAttribute('fill', labelColor);
            dimEl.textContent = formatMeters(extentM);
            previewFullZones.appendChild(dimEl);
          } else {
            var dimColor = fb.zoneNum === 1 ? '#d1352b' : '#1f8fa8';
            var dimEl2 = document.createElementNS('http://www.w3.org/2000/svg', 'text');
            dimEl2.setAttribute('x', offsetX + (fb.x + fb.w / 2) * scale);
            dimEl2.setAttribute('y', offsetY + (fb.y + fb.h / 2) * scale + 16);
            dimEl2.setAttribute('text-anchor', 'middle');
            dimEl2.setAttribute('class', 'm2-calc__preview-full-dim');
            dimEl2.setAttribute('fill', dimColor);
            dimEl2.textContent = formatMeters(extentM);
            previewFullZones.appendChild(dimEl2);
          }
        });
      }
      previewZoneLabels.innerHTML = '';
      s.zoneLabels.forEach(function (zl) {
        if (!zl.text) return;
        var el = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        el.setAttribute('x', offsetX + zl.x * scale); el.setAttribute('y', offsetY + zl.y * scale);
        el.setAttribute('text-anchor', 'middle'); el.setAttribute('class', 'm2-calc__preview-zone-label'); el.textContent = zl.text;
        previewZoneLabels.appendChild(el);
      });
      previewLabels.innerHTML = '';
      s.labels.forEach(function (lbl) {
        if (!lbl.text) return;
        var off = DIR_OFFSETS[lbl.dir];
        var el = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        el.setAttribute('x', offsetX + lbl.x * scale + off.dx); el.setAttribute('y', offsetY + lbl.y * scale + off.dy);
        el.setAttribute('text-anchor', off.anchor); el.setAttribute('class', 'm2-calc__preview-label'); el.textContent = lbl.text;
        previewLabels.appendChild(el);
      });
    }

    function resetDimensions() {
      l1.value = ''; w1.value = ''; l2.value = ''; w2.value = '';
      shifted = false;
      if (shiftBtn) shiftBtn.classList.remove('is-active');
      rotationSteps = 0;
      recalc();
    }
    function setShape(newShape) {
      shape = newShape;
      shapeButtons.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-shape') === newShape); });
      var isL = newShape === 'l';
      lshapeWrap.hidden = !isL; lshapeDimsWrap.hidden = !isL;
      if (shiftBtn) shiftBtn.hidden = !isL;
      zone1Label.hidden = !isL;
      root.querySelectorAll('[data-calc-zone-length][data-rect="2"], [data-calc-zone-length-manual][data-rect="2"]').forEach(function (el) { el.hidden = !isL; });
      resetDimensions();
    }
    shapeButtons.forEach(function (b) { b.addEventListener('click', function () { setShape(b.getAttribute('data-shape')); }); });

    var resetBtn = root.querySelector('[data-calc-reset]');
    if (resetBtn) resetBtn.addEventListener('click', function () { resetDimensions(); });

    [l1, w1, l2, w2].forEach(function (input) { input.addEventListener('input', function () { recalc(); }); });

    function renderColorPicker() {
      var colors = getAvailableColors();
      colorBlock.hidden = colors.length === 0;
      colorPickerEl.innerHTML = '';
      colors.forEach(function (ck) {
        var btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'm2-calc__variant-btn';
        btn.textContent = ck;
        btn.classList.toggle('is-active', state.colorKey === ck);
        btn.addEventListener('click', function () {
          if (state.colorKey === ck) return;
          var availableWidthsForNewColor = getAvailableWidths(ck);
          state.colorKey = ck;
          if (state.widthCm !== null && availableWidthsForNewColor.indexOf(state.widthCm) === -1) {
            state.widthCm = null;
            state.zoneLengthWild = { 1: null, 2: null };
          }
          renderColorPicker(); renderWidthPicker(); recalc();
        });
        colorPickerEl.appendChild(btn);
      });
    }

    function renderWidthPicker() {
      var widths = getAvailableWidths(state.colorKey);
      if (widths.length === 1 && state.widthCm !== widths[0]) {
        state.widthCm = widths[0];
      }
      var onlyOneWidth = widths.length <= 1;
      widthBlock.hidden = onlyOneWidth ? true : (colorBlock.hidden ? false : (state.colorKey === null && getAvailableColors().length > 0));
      widthPickerEl.innerHTML = '';
      widths.forEach(function (wCm) {
        var btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'm2-calc__variant-btn';
        btn.textContent = wCm + mmLabel;
        btn.classList.toggle('is-active', state.widthCm === wCm);
        btn.addEventListener('click', function () {
          if (state.widthCm === wCm) return;
          var newLengths = getAvailableLengths(state.colorKey, wCm);
          state.widthCm = wCm;
          [1, 2].forEach(function (rn) {
            if (state.zoneLengthWild[rn] !== null && newLengths.indexOf(state.zoneLengthWild[rn]) === -1) state.zoneLengthWild[rn] = null;
          });
          renderWidthPicker();
          recalc();
        });
        widthPickerEl.appendChild(btn);
      });
    }

    methodButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buildMethod = btn.getAttribute('data-method');
        methodButtons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        recalc();
      });
    });

    function renderLengthPicker(container, rectNum, lengths, selectedGetter, selectedSetter) {
      container.innerHTML = '';
      lengths.forEach(function (lenM) {
        var btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'm2-calc__variant-btn';
        btn.textContent = formatMeters(lenM);
        btn.classList.toggle('is-active', selectedGetter(rectNum) === lenM);
        btn.addEventListener('click', function () { selectedSetter(rectNum, lenM); recalc(); });
        container.appendChild(btn);
      });
    }

    function renderProposalBox(container, titleHtml, titleClass, lines, alternatives, currentIndex, onChooseAlt, noteText) {
      container.innerHTML = '';
      var titleEl = document.createElement('p');
      titleEl.className = 'm2-calc__proposal-title ' + titleClass;
      titleEl.innerHTML = titleHtml;
      container.appendChild(titleEl);
      lines.forEach(function (lineHtml) {
        var p = document.createElement('p');
        p.className = 'm2-calc__proposal-line';
        p.innerHTML = lineHtml;
        container.appendChild(p);
      });
      if (alternatives && alternatives.length > 1) {
        var note = document.createElement('p');
        note.className = 'm2-calc__alt-note';
        note.textContent = noteText;
        container.appendChild(note);
        var pickerDiv = document.createElement('div');
        pickerDiv.className = 'm2-calc__variants';
        alternatives.forEach(function (alt, idx) {
          var btn = document.createElement('button');
          btn.type = 'button'; btn.className = 'm2-calc__variant-btn';
          btn.textContent = alt.label;
          btn.classList.toggle('is-active', idx === currentIndex);
          btn.addEventListener('click', function () { onChooseAlt(idx); });
          pickerDiv.appendChild(btn);
        });
        container.appendChild(pickerDiv);
      }
    }

    function recalc() {
      updatePreview();

      if (!buildDirection) return;

      var area1 = (parseFloat(l1.value) || 0) * (parseFloat(w1.value) || 0);
      var area2 = shape === 'l' ? (parseFloat(l2.value) || 0) * (parseFloat(w2.value) || 0) : 0;
      var needsRect2 = shape === 'l';
      var shapeReady = area1 > 0 && (!needsRect2 || area2 > 0);

      afterShape.hidden = !shapeReady;

      if (!shapeReady) {
        elHint.textContent = defaultHintText;
        elHint.hidden = false;
        elPlankOptions.hidden = true;
        elResults.hidden = true;
        if (!adviesRevealed) root.classList.add('m2-advies-pending');
        elAdd.disabled = true;
        return;
      }

      renderColorPicker();
      renderWidthPicker();

      if (state.widthCm === null) {
        elHint.hidden = false;
        elPlankOptions.hidden = true;
        elResults.hidden = true;
        perfectProposalEl.hidden = true;
        methodBlock.hidden = true;
        wildLengthBlock.hidden = true;
        fullAutoBlock.hidden = true;
        if (!adviesRevealed) root.classList.add('m2-advies-pending');
        elAdd.disabled = true;
        return;
      }

      var lengths = getAvailableLengths(state.colorKey, state.widthCm);
      var refVariantId = variantFor(state.colorKey, state.widthCm, lengths[0]);
      var refVariant = refVariantId ? variants[refVariantId] : null;
      var numRows1 = refVariant ? getNumRows(1, refVariant.plankWidthCm) : 0;
      var row1 = getRowInfo(1).rowLength;
      var row2 = 0, numRows2 = 0;
      if (needsRect2) { row2 = getRowInfo(2).rowLength; numRows2 = refVariant ? getNumRows(2, refVariant.plankWidthCm) : 0; }

      var perfectOptions = findPerfectNoCutOptions(row1, needsRect2 ? row2 : 0, lengths);

      var v1 = null, v2 = null;
      var planks1 = 0, planks2 = 0;
      currentSpareEntries = [];
      currentUsageQty = {};
      currentFullVisual = null;
      var usingPerfect = false;

      if (perfectOptions.length > 0) {
        usingPerfect = true;
        perfectProposalEl.hidden = false;
        methodBlock.hidden = true;
        wildLengthBlock.hidden = true;
        fullAutoBlock.hidden = true;

        if (state.perfectChoiceIndex >= perfectOptions.length) state.perfectChoiceIndex = 0;
        var chosenPerfect = perfectOptions[state.perfectChoiceIndex];

        var lines = [];
        var mainPerRow1 = Math.round(row1 / chosenPerfect.length1);
        planks1 = numRows1 * mainPerRow1;
        lines.push('<strong>' + planks1 + '</strong> ' + planksOfLabel + ' ' + formatMeters(chosenPerfect.length1) + (needsRect2 ? ' \u2014 ' + forZone1Label : ''));
        if (needsRect2 && chosenPerfect.length2) {
          var mainPerRow2 = Math.round(row2 / chosenPerfect.length2);
          planks2 = numRows2 * mainPerRow2;
          lines.push('<strong>' + planks2 + '</strong> ' + planksOfLabel + ' ' + formatMeters(chosenPerfect.length2) + ' \u2014 ' + forZone2Label);
        }

        var altLabels = perfectOptions.map(function (opt) {
          return needsRect2 ? (formatMeters(opt.length1) + ' / ' + formatMeters(opt.length2)) : formatMeters(opt.length1);
        });
        var altObjs = perfectOptions.map(function (opt, idx) { return { label: altLabels[idx] }; });
        renderProposalBox(perfectProposalEl, perfectTitleLabel, '', lines, altObjs, state.perfectChoiceIndex, function (idx) {
          state.perfectChoiceIndex = idx; recalc();
        }, perfectAltNoteLabel);

        v1 = variantFor(state.colorKey, state.widthCm, chosenPerfect.length1) ? variants[variantFor(state.colorKey, state.widthCm, chosenPerfect.length1)] : null;
        rectState[1].variantId = variantFor(state.colorKey, state.widthCm, chosenPerfect.length1);
        if (needsRect2 && chosenPerfect.length2) {
          v2 = variantFor(state.colorKey, state.widthCm, chosenPerfect.length2) ? variants[variantFor(state.colorKey, state.widthCm, chosenPerfect.length2)] : null;
          rectState[2].variantId = variantFor(state.colorKey, state.widthCm, chosenPerfect.length2);
        }
      } else {
        perfectProposalEl.hidden = true;
        methodBlock.hidden = false;

        if (!buildMethod) {
          wildLengthBlock.hidden = true;
          fullAutoBlock.hidden = true;
          elHint.hidden = false;
          elPlankOptions.hidden = true;
          elResults.hidden = true;
          if (!adviesRevealed) root.classList.add('m2-advies-pending');
          elAdd.disabled = true;
          return;
        }

        if (buildMethod === 'wild') {
          fullAutoBlock.hidden = true;
          wildLengthBlock.hidden = false;
          var onlyOneLength = lengths.length <= 1;
          if (onlyOneLength) {
            if (state.zoneLengthWild[1] !== lengths[0]) state.zoneLengthWild[1] = lengths[0] || null;
            if (needsRect2 && state.zoneLengthWild[2] !== lengths[0]) state.zoneLengthWild[2] = lengths[0] || null;
          }

          var z1Row = root.querySelector('[data-calc-zone-length][data-rect="1"]');
          z1Row.hidden = onlyOneLength;
          z1Row.querySelector('[data-calc-zone-length-label]').textContent = needsRect2 ? (zone1TitleLabel + ' \u2014 ' + chooseLengthLabel) : chooseLengthLabel;
          renderLengthPicker(z1Row.querySelector('[data-calc-length-picker]'), 1, lengths,
            function (rn) { return state.zoneLengthWild[rn]; },
            function (rn, val) { state.zoneLengthWild[rn] = val; recalc(); });

          if (needsRect2) {
            var z2Row = root.querySelector('[data-calc-zone-length][data-rect="2"]');
            z2Row.hidden = onlyOneLength;
            z2Row.querySelector('[data-calc-zone-length-label]').textContent = zone2TitleLabel + ' \u2014 ' + chooseLengthLabel;
            renderLengthPicker(z2Row.querySelector('[data-calc-length-picker]'), 2, lengths,
              function (rn) { return state.zoneLengthWild[rn]; },
              function (rn, val) { state.zoneLengthWild[rn] = val; recalc(); });
          }

          if (state.zoneLengthWild[1] !== null) {
            var v1id = variantFor(state.colorKey, state.widthCm, state.zoneLengthWild[1]);
            v1 = v1id ? variants[v1id] : null;
            rectState[1].variantId = v1id;
            if (v1) planks1 = calcPlanksWild(getRowInfo(1).rowLength, getRowInfo(1).crossDim, v1);
          }
          if (needsRect2 && state.zoneLengthWild[2] !== null) {
            var v2id = variantFor(state.colorKey, state.widthCm, state.zoneLengthWild[2]);
            v2 = v2id ? variants[v2id] : null;
            rectState[2].variantId = v2id;
            if (v2) planks2 = calcPlanksWild(getRowInfo(2).rowLength, getRowInfo(2).crossDim, v2);
          }

          if (v1 && (!needsRect2 || v2)) {
            var wildLines = [];
            wildLines.push('<strong>' + planks1 + '</strong> ' + planksOfLabel + ' ' + formatMeters(state.zoneLengthWild[1]) + (needsRect2 ? ' \u2014 ' + forZone1Label : ''));
            if (needsRect2) {
              wildLines.push('<strong>' + planks2 + '</strong> ' + planksOfLabel + ' ' + formatMeters(state.zoneLengthWild[2]) + ' \u2014 ' + forZone2Label);
            }
            wildSummaryEl.hidden = false;
            wildSummaryEl.innerHTML = '';
            wildLines.forEach(function (lineHtml) {
              var p = document.createElement('p');
              p.className = 'm2-calc__proposal-line';
              p.innerHTML = lineHtml;
              wildSummaryEl.appendChild(p);
            });
          } else {
            wildSummaryEl.hidden = true;
            wildSummaryEl.innerHTML = '';
          }
        } else {
          wildLengthBlock.hidden = true;
          fullAutoBlock.hidden = false;

          var results = optimizeFullMethod(row1, numRows1, needsRect2 ? row2 : 0, needsRect2 ? numRows2 : 0, lengths);
          if (state.fullChoiceIndex >= (results ? results.length : 0)) state.fullChoiceIndex = 0;
          var chosenFull = results ? results[state.fullChoiceIndex] : null;

          if (chosenFull) {
            var fLines = describeFullResult(chosenFull, needsRect2);
            var fAlts = results.map(function (r) { return { label: formatMeters(r.mainLengthM) }; });
            renderProposalBox(fullProposalEl, fullProposalTitleLabel, 'm2-calc__proposal-title--full', fLines, fAlts, state.fullChoiceIndex, function (idx) {
              state.fullChoiceIndex = idx; recalc();
            }, fullAltNoteLabel);
            planks1 = chosenFull.mainTotal1;
            if (needsRect2) planks2 = chosenFull.mainTotal2;
            var mainVarId = variantFor(state.colorKey, state.widthCm, chosenFull.mainLengthM);
            v1 = mainVarId ? variants[mainVarId] : null;
            rectState[1].variantId = mainVarId;
            if (needsRect2) { v2 = v1; rectState[2].variantId = mainVarId; }

            currentFullVisual = {
              zone1: { mainPerRow: chosenFull.mainPerRow1, mainLengthM: chosenFull.mainLengthM, rem: chosenFull.rem1 },
              zone2: needsRect2 ? { mainPerRow: chosenFull.mainPerRow2, mainLengthM: chosenFull.mainLengthM, rem: chosenFull.rem2 } : null
            };

            if (chosenFull.sparePlanks > 0) {
              chosenFull.sparePatternUsage.forEach(function (pu) {
                if (pu.lengthM == null || !pu.count) return;
                var spareVarId = variantFor(state.colorKey, state.widthCm, pu.lengthM);
                if (spareVarId) currentSpareEntries.push({ variantId: spareVarId, qty: pu.count });
              });
            }
          } else {
            fullProposalEl.innerHTML = '';
          }
        }
      }

      updatePreview();

      var dimsAndPlankReady = v1 && (!needsRect2 || v2);
      if (!dimsAndPlankReady) {
        elHint.hidden = false;
        elPlankOptions.hidden = true;
        elResults.hidden = true;
        if (!adviesRevealed) root.classList.add('m2-advies-pending');
        elAdd.disabled = true;
        return;
      }

      elHint.hidden = true;
      elPlankOptions.hidden = false;

      var totalArea = area1 + (needsRect2 ? area2 : 0);
      elArea.textContent = totalArea.toFixed(2).replace('.', ',') + ' m\u00B2';

      var usageQty = {};
      function addUsage(id, qty) {
        if (!id || !qty) return;
        usageQty[id] = (usageQty[id] || 0) + qty;
      }
      addUsage(rectState[1].variantId, planks1);
      if (needsRect2) addUsage(rectState[2].variantId, planks2);
      currentSpareEntries.forEach(function (entry) { addUsage(entry.variantId, entry.qty); });
      var usageVariantIds = Object.keys(usageQty);
      currentUsageQty = usageQty;

      var totalCents = 0;
      var totalPlanks = 0;
      elPriceRows.innerHTML = '';
      usageVariantIds.forEach(function (vid) {
        var qty = usageQty[vid];
        var v = variants[vid];
        if (!v) return;
        totalCents += qty * v.price;
        totalPlanks += qty;
        var row = document.createElement('div');
        row.className = 'm2-calc__row';
        row.innerHTML = '<span>' + qty + ' ' + piecesLabel + ' \u2014 ' + v.title + '</span>' +
          '<strong>' + formatMoney(v.price) + ' (' + formatMoney(v.price / v.m2) + '/m\u00B2)</strong>';
        elPriceRows.appendChild(row);
      });

      elTotalLabel.textContent = isProfessional ? totalParticulierLabel : totalPlainLabel;
      elTotal.textContent = formatMoney(totalCents);

      var proReady = usageVariantIds.length > 0 && usageVariantIds.every(function (vid) { return proUnitCentsByVariant[vid] != null; });
      if (proReady) {
        var proTotalCents = 0;
        elProPriceRows.innerHTML = '';
        usageVariantIds.forEach(function (vid) {
          var qty = usageQty[vid];
          var v = variants[vid];
          if (!v) return;
          var proCents = proUnitCentsByVariant[vid];
          proTotalCents += qty * proCents;
          var row = document.createElement('div');
          row.className = 'm2-calc__row';
          row.innerHTML = '<span>' + qty + ' ' + piecesLabel + ' \u2014 ' + v.title + '</span>' +
            '<strong>' + formatMoney(proCents) + ' (' + formatMoney(proCents / v.m2) + '/m\u00B2)</strong>';
          elProPriceRows.appendChild(row);
        });
        elProTotal.textContent = formatMoney(proTotalCents) + ' ' + exclVatLabel;
        elVoordeel.textContent = formatMoney(totalCents - proTotalCents);
        elProGroup.hidden = false;
      } else {
        elProGroup.hidden = true;
      }

      elResults.hidden = false;
      root.classList.remove('m2-advies-pending');
      adviesRevealed = true;
      var allAvailable = usageVariantIds.every(function (vid) { var v = variants[vid]; return v && v.available; });
      elAdd.disabled = !allAvailable;
      elAdd.textContent = allAvailable ? addLabelBase + ' (' + totalPlanks + ' ' + piecesLabel + ')' : addLabelBase;

      if (isProfessional) {
        usageVariantIds.forEach(function (vid) { requestProSync(vid); });
      }
    }

    function refreshCartCountBadges() {
      fetch('/cart.js').then(function (res) { return res.json(); }).then(function (cart) {
        var selectors = '.cart-count, [data-cart-count], #CartCount, .js-cart-count, .cart-link__bubble, .cart-count-bubble';
        document.querySelectorAll(selectors).forEach(function (el) { el.textContent = cart.item_count; });
      }).catch(function () {});
    }

    elAdd.addEventListener('click', function () {
      var variantIds = Object.keys(currentUsageQty);
      if (!variantIds.length) return;
      var items = variantIds.map(function (id) { return { id: parseInt(id, 10), quantity: currentUsageQty[id] }; });

      elAdd.disabled = true; elAdd.textContent = addingLabel; elAddError.hidden = true;

      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (res) { if (!res.ok) return res.json().then(function (j) { throw new Error(j.description || 'Error'); }); return res.json(); })
        .then(function () {
          elAdd.textContent = addedLabel;
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          refreshCartCountBadges();
          setTimeout(function () { elAdd.disabled = false; recalc(); }, 2000);
        })
        .catch(function (err) { elAdd.disabled = false; recalc(); elAddError.textContent = err.message; elAddError.hidden = false; });
    });

    function syncProPricing(variantId, done) {
      var mainProductEl = document.querySelector('[data-section-type="product"]');
      var sectionId = mainProductEl ? mainProductEl.getAttribute('data-section-id') : null;
      var productUrl = root.getAttribute('data-product-url');
      if (!sectionId || !productUrl) { done(); return; }
      var url = productUrl + '?variant=' + variantId + '&section_id=' + sectionId;
      var finished = false;
      function finish() {
        if (finished) return;
        finished = true;
        done();
      }
      fetch(url).then(function (res) { return res.text(); }).then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var priceId = 'product-price-' + calcData.productId;
        var fresh = doc.getElementById(priceId); var live = document.getElementById(priceId);
        if (!fresh || !live) { finish(); return; }
        live.innerHTML = fresh.innerHTML;
        live.querySelectorAll('script').forEach(function (oldScript) {
          var newScript = document.createElement('script');
          if (oldScript.src) newScript.src = oldScript.src; else newScript.textContent = oldScript.textContent;
          oldScript.parentNode.replaceChild(newScript, oldScript);
        });
        var attempts = 0, maxAttempts = 20;
        var poll = setInterval(function () {
          attempts++;
          var proCell = live.querySelector('.prindal-m2-pro-cell[data-m2-pro-unit-placeholder]');
          if (proCell && proCell.getAttribute('data-filled-for') === String(variantId)) {
            var text = proCell.textContent || '';
            var num = parseFloat(text.replace(/[^\d,.-]/g, '').replace(',', '.'));
            if (num) { proUnitCentsByVariant[variantId] = Math.round(num * 100); recalc(); }
            clearInterval(poll);
            finish();
          } else if (attempts >= maxAttempts) { clearInterval(poll); finish(); }
        }, 300);
      }).catch(function () { finish(); });
    }
  }

  return { init: init };
})();